<template>
  <div class="layout-portal"
       v-loading="loading"
       element-loading-text="首页配置加载中...">
    <AsyncComponent v-if="portal.componentPath"
                    :component-path="portal.componentPath"
                    v-bind="portal.componentParam"></AsyncComponent>
  </div>
</template>

<script>
import AsyncComponent from '../elements/async/AsyncComponent'
export default {
  name: 'LayoutPortal',
  components: {
    AsyncComponent
  },
  data () {
    return {
      loading: false,
      defaultPortalPath: 'portal/default/index.vue',
      portal: {
        componentPath: null,
        componentParam: null
      }
    }
  },
  methods: {
    loadPortalConfig () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/center/portal',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.handlePortalConfig(response.data['portalConfig'] || {})
              break
            }
            default: {
              this.$message.error(response.data['message'])
              break
            }
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePortalConfig ({name, icon, componentPath, params}) {
      this.portal.componentPath = componentPath || this.defaultPortalPath
      let componentParam = {}
      if (params) {
        params.forEach(param => {
          componentParam[param.name] = param.value
        })
      }
      this.portal.componentParam = componentParam
      this.$store.commit('updatePortalTab', {
        label: name,
        icon: icon
      })
    }
  },
  mounted () {
    this.loadPortalConfig()
  }
}
</script>

<style lang="scss">
  .layout-portal {
    height: 100%;
    box-sizing: border-box;
    & > .template-data-grid,
    & > .template-data-page,
    & > .template-data-step,
    & > .template-data-tabs,
    & > .template-data-tree {
      padding: 10px;
    }
  }
</style>
